"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable camelcase */
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const client_1 = require("@apollo/client");
//
// assets
//
const queryDefinitions_1 = require("queryDefinitions");
//
// styles
//
const polaris_1 = require("@shopify/polaris");
const StyledWrapper_1 = require("./StyledWrapper");
const StyledMain_1 = require("./StyledMain");
const StyledContainer_1 = require("./StyledContainer");
const StyledHeader_1 = require("./StyledHeader");
const StyledHeaderContainer_1 = require("components/Dashboard/StyledHeaderContainer");
const StyledSubHeader_1 = require("components/Dashboard/StyledSubHeader");
const StyledMessageContainer_1 = require("components/Dashboard/StyledMessageContainer");
const LoadingSpinner_1 = __importDefault(require("components/general/LoadingSpinner"));
const StyledMediumText_1 = require("components/Dashboard/StyledMediumText");
const StyledErrorText_1 = require("components/Dashboard/StyledErrorText");
const AccountContext_1 = require("contexts/AccountContext");
function getReportTitle(metabaseId) {
    return {
        active_orders: 'Active Orders',
        problem_orders: 'Problem Orders',
        shipping_performance: 'Shipping Performance'
    }[metabaseId];
}
const Metabase = () => {
    const { metabaseId } = (0, react_router_dom_1.useParams)();
    const { account } = (0, AccountContext_1.useAccount)();
    const [url, setUrl] = (0, react_1.useState)('');
    const [getEmbeddedDashboard, { loading, error, data }] = (0, client_1.useLazyQuery)(queryDefinitions_1.GET_EMBEDDED_DASHBOARD);
    (0, react_1.useEffect)(() => {
        if ((account === null || account === void 0 ? void 0 : account.id) && metabaseId) {
            getEmbeddedDashboard({
                variables: {
                    id: metabaseId,
                    accountId: account.id
                }
            });
        }
    }, [account === null || account === void 0 ? void 0 : account.id, metabaseId]);
    (0, react_1.useEffect)(() => {
        var _a;
        if (!loading && !error && ((_a = data === null || data === void 0 ? void 0 : data.embeddedDashboard) === null || _a === void 0 ? void 0 : _a.url)) {
            setUrl(data.embeddedDashboard.url);
        }
    }, [loading, data]);
    function renderHeader() {
        if (metabaseId === 'problem_orders') {
            return (react_1.default.createElement(StyledHeader_1.StyledHeader, { className: 'header', role: 'heading', width: '14rem;' },
                getReportTitle(metabaseId),
                react_1.default.createElement(polaris_1.Badge, { status: 'success' }, "Beta")));
        }
        return (react_1.default.createElement(StyledHeader_1.StyledHeader, { className: 'header', role: 'heading' }, getReportTitle(metabaseId)));
    }
    if (error) {
        if (error.message.includes('ECONNREFUSED') ||
            error.message.toLowerCase().includes('failed')) {
            return (react_1.default.createElement(StyledErrorText_1.StyledErrorText, { className: 'error', role: 'alert' }, "The server could not be reached, please try again later"));
        }
        return (react_1.default.createElement(StyledErrorText_1.StyledErrorText, { className: 'error', role: 'alert' }, error.message));
    }
    if (loading && url === '') {
        return (react_1.default.createElement(StyledMessageContainer_1.StyledMessageContainer, null,
            react_1.default.createElement(LoadingSpinner_1.default, null),
            react_1.default.createElement(StyledMediumText_1.StyledMediumText, { className: 'loading', role: 'paragraph' }, "Loading")));
    }
    return (react_1.default.createElement(StyledWrapper_1.StyledWrapper, { className: 'fade show' },
        react_1.default.createElement(StyledMain_1.StyledMain, { className: 'metabase' },
            react_1.default.createElement(StyledHeaderContainer_1.StyledHeaderContainer, null,
                react_1.default.createElement("div", null,
                    react_1.default.createElement(StyledSubHeader_1.StyledSubHeader, { className: 'header', role: 'heading' }, "REPORTS"),
                    renderHeader())),
            react_1.default.createElement(StyledContainer_1.StyledContainer, null,
                react_1.default.createElement("iframe", { height: '100%', src: url, width: '100%' })))));
};
exports.default = Metabase;
